import * as React from "react";

import "./menu.scss";

import {cs}       from "@Common/react/chain-services";

export const MenuHeaderDesktop = ({profile}) => cs(
    ({}) => (
        <div className="header">
            <div className="icon" xd-qa-name="icon" xd-qa-type="image">
                {profile.icon}
            </div>
            <div className="details">
                <div className="label" xd-qa-name="label" xd-qa-type="label">
                    {profile.label}
                </div>
                <div className="subLabel" xd-qa-name="subLabel" xd-qa-type="label">
                    {profile?.subLabel}
                </div>
            </div>
        </div>
    )
);